module.exports = __webpack_public_path__ + "media/images/icon/icons8-Bullish-886312428c4c9733cd13b4ed6683062a.png";